import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { Provider } from 'react-redux'
import { applyMiddleware, createStore } from 'redux'
import { thunk } from 'redux-thunk'
import reducers from '../reducers'
import { ThemeProvider, createTheme } from '@mui/material';


import Colors from '../helpers/colors'

import PropertiesRouteMiddleware from './tags/RouteMiddleware/PropertiesRouteMiddleware'
import { getConfiguration } from '../helpers/configuration'
import UserAuthentication from './tags/RouteMiddleware/UserAuthentication'
import Login from './tags/RouteMiddleware/Login'
import ReservoirAuthToken from './tags/RouteMiddleware/ReservoirAuthToken'
import CurrentUser from './tags/RouteMiddleware/CurrentUser'
import CourseCheckpoint from './tags/RouteMiddleware/CourseCheckpoint'
import Page from './tags/RouteMiddleware/Page'
import SurveySubmit from './tags/SurveySubmit'
import StudentSurvey from './pages/StudentSurvey'
import DefaultTileFilters from './tags/RouteMiddleware/DefaultTileFilters'
import Layout from './tags/Layout'
import CheckForMaintenance from './tags/RouteMiddleware/CheckForMaintenance'
import Home from './pages/Home'
import Favourites from './pages/Favourites'
import FinancialSupport from './pages/FinancialSupport'
import Notifications from './pages/Notifications'
import Enrolments from './pages/Enrolments'
import Settings from './pages/Settings'
import UsiDetails from './pages/UsiDetails'
import Finances from './pages/Finances'
import SecondaryPage from './pages/SecondaryPage'
import ParallelLoad from './tags/RouteMiddleware/ParallelLoad'
import Reports from './pages/Reports'

const muiTheme = createTheme({
  palette: {
    primary: { main: Colors.lochmara },
    accent: { main: Colors.lochmara }
  },
  overrides: {
    MuiDrawer: {
      root: {
        color: Colors.elephant
      },
      docked: {
        color: Colors.elephant
      }
    },
    MuiFormLabel: {
      root: {
        color: Colors.loblollyWcag
      }
    },
    MuiInputBase: {
      input: {
        borderColor: Colors.loblolly
      }
    },
    MuiTextField: {
      root: {
        color: Colors.loblolly
      }
    },
    MuiSlider: {
      root: {
        color: Colors.grandis,
        marginBottom: '40px',
        marginTop: '10px'
      },
      rail: {
        height: 4
      },
      thumb: {
        height: 16,
        width: 16
      },
      track: {
        height: 4
      }
    }
  },
  typography: {
    fontFamily: ['Roboto', 'sans-serif'].join(',')
  }
});

const Routes = () => (
  <Switch>
    <Route path={getConfiguration('publicPath')} exact component={Home} />
    <Route path={getConfiguration('baseUrl') + '/favourites'} component={Favourites} />
    <Route path={getConfiguration('baseUrl') + '/financial-support'} component={FinancialSupport} />
    <Route path={getConfiguration('baseUrl') + '/notifications'} component={Notifications} />
    <Route path={getConfiguration('baseUrl') + '/enrolments'} component={Enrolments} />
    <Route path={getConfiguration('baseUrl') + '/settings'} component={Settings} />
    <Route path={getConfiguration('baseUrl') + '/usidetails'} component={UsiDetails} />
    <Route path={getConfiguration('baseUrl') + '/finances'} component={Finances} />
    <Route path={getConfiguration('baseUrl') + '/reports/:reportType'} component={Reports} />
    <Route path={getConfiguration('baseUrl') + '/:pageSlug'} component={SecondaryPage} />
  </Switch>
)

export const App = () => {
  return (
    <Provider store={createStore(reducers, applyMiddleware(thunk))}>
      <ThemeProvider theme={muiTheme}>
        <Router>
          <Switch>
            <Route exact path={getConfiguration('baseUrl') + '/login'} component={Login} />
            <Route path={getConfiguration('baseUrl')}>
              <UserAuthentication>
                <PropertiesRouteMiddleware>
                  <CheckForMaintenance>
                    <ReservoirAuthToken>
                      <CurrentUser>
                        <ParallelLoad>
                          <CourseCheckpoint>
                            <Page>
                              <Switch>
                                <Route path={getConfiguration('baseUrl') + '/afs/results'} component={SurveySubmit} />
                                <Route path={getConfiguration('baseUrl') + '/afs'} component={StudentSurvey} />
                                <Route
                                  render={() => {
                                    return (
                                      <DefaultTileFilters>
                                        <Layout>
                                          <Routes />
                                        </Layout>
                                      </DefaultTileFilters>
                                    )
                                  }}
                                />
                              </Switch>
                            </Page>
                          </CourseCheckpoint>
                        </ParallelLoad>
                      </CurrentUser>
                    </ReservoirAuthToken>
                  </CheckForMaintenance>
                </PropertiesRouteMiddleware>
              </UserAuthentication>
            </Route>
          </Switch>
        </Router>
      </ThemeProvider>
    </Provider>
  )
}